import React from 'react'
import { Link, useNavigate, generatePath } from 'react-router-dom'
import { Card, Button } from 'react-bootstrap'
import { Router } from 'app'
import { WideContainer } from 'component/Layout'
import { AboutContent } from './AboutPage'
import { ContactContent } from './ContactPage'
import { TermsContent } from './TermsPage'

const CoursesInfo = () => {
	const navigate = useNavigate()
	return <>
		<h4>All courses</h4>
		<Card>
			<Card.Body>
				<Card.Title>
					<h5><Link to={generatePath(Router.routes.COURSE_VIEW.path, { course_name: 'mpiEntrance' })}>Practice tests for M. Prakash Institute's Std XI JEE entrance exam</Link></h5>
				</Card.Title>
				<div className="d-flex align-items-center gap-2">
				Complete set of 10 fresh papers, arranged by difficulty. Sample papers available available for free.
				</div>
			</Card.Body>
		</Card>
		<Card>
			<Card.Body>
				<Card.Title>
					<h5><Link to={generatePath(Router.routes.COURSE_VIEW.path, { course_name: 'prmoPractice' })}>IOQM question bank</Link></h5>
				</Card.Title>
				<div className="d-flex align-items-center gap-2">
				Fresh problem sets added every week.
				</div>
			</Card.Body>
		</Card>
		<Card>
			<Card.Body>
				<Card.Title>
					<h5><Link to={generatePath(Router.routes.COURSE_VIEW.path, { course_name: 'pradnyaSolutions' })}>Pradnya paper solutions for Std V</Link></h5>
				</Card.Title>
				<div className="d-flex align-items-center gap-2">
				Complete set of 7 paper solutions (2010-2016). Sample solutions available for free.
				</div>
			</Card.Body>
		</Card>
		<Card>
			<Card.Body>
				<Card.Title>
					<h5><Link to={generatePath(Router.routes.COURSE_VIEW.path, { course_name: 'prabhutvaSolutions' })}>Prabhutva level-2 paper solutions for Std V</Link></h5>
				</Card.Title>
				<div className="d-flex align-items-center gap-2">
				Complete set of 7 paper solutions (2012-2018). Sample solutions available for free.
				</div>
			</Card.Body>
		</Card>
		<Card>
			<Card.Body>
				<Card.Title>
					<h5><Link to={generatePath(Router.routes.COURSE_VIEW.path, { course_name: 'ipmMegafinalSolutions2014' })}>IPM Megafinal 2014 paper solutions</Link></h5>
				</Card.Title>
				<div className="d-flex align-items-center gap-2">
				Complete set of 4 paper solutions (Std 2 to Std 5). Sample solutions available for free.
				</div>
			</Card.Body>
		</Card>
	</>
}

export const IndexPage = () =>
	<WideContainer>
		<CoursesInfo />
		<br />
		<AboutContent />
		<br />
		<ContactContent />
		<br />
		<TermsContent />
	</WideContainer>
